// extracted by mini-css-extract-plugin
module.exports = {"w9st8ae":"w9st8ae"};